import { render, staticRenderFns } from "./tickets-by-types.vue?vue&type=template&id=390dd0ce"
import script from "./tickets-by-types.vue?vue&type=script&lang=js"
export * from "./tickets-by-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports